module.exports = __webpack_public_path__ + "static/media/Abandonar_conferencia.6bfb5571.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/TransferCall/Abandonar_conferencia.svg
// module id = 1840
// module chunks = 0